'use client'

import DOMPurify from 'isomorphic-dompurify'
import styles from './styles.module.scss'
import footerData from '@/constants/footer.json'

export default function SimpleFooter() {
  const { footerBottom } = footerData

  return (
    <footer className={styles.simpleFooter}>
      <div className={styles.container}>
        <small
          className={styles.copyright}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(footerBottom.copylight) }}
        />
      </div>
    </footer>
  )
}
